import React from 'react';

function MacroSkeleton() {
  return (
    <div className="bg-white rounded-lg shadow-md p-4">
      <h3 className="text-lg font-semibold text-gray-700 mb-3 h-6 bg-gray-200 rounded w-48">
        <span className="sr-only">Loading macro title</span>
      </h3>
      <div className="grid grid-cols-2 gap-4 animate-pulse">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="bg-gray-50 rounded-lg p-3 flex items-center">
            <div className="w-10 h-10 bg-gray-200 rounded-full mr-3"></div>
            <div>
              <div className="h-4 bg-gray-200 rounded w-16 mb-2"></div>
              <div className="h-6 bg-gray-200 rounded w-20"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MacroSkeleton;
